import { render, staticRenderFns } from "./handle-info-item.vue?vue&type=template&id=46a7fa14&scoped=true&"
import script from "./handle-info-item.vue?vue&type=script&lang=js&"
export * from "./handle-info-item.vue?vue&type=script&lang=js&"
import style0 from "./handle-info-item.vue?vue&type=style&index=0&id=46a7fa14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a7fa14",
  null
  
)

export default component.exports